import Client from './ApiClient'

const resource = 'auth'

const signIn = (data) => {
  return Client.post(`${resource}/sign_in`, data)
}

export default { signIn }
